import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../utils';

export const setMutedTagsWidgetBlacklistedTags = createAction(
  `${reduxKey}.SET_MUTEDTAGS_WIDGET_BLACKLISTED_TAGS`,
  (blacklistedTags: { name: string }[]) => ({ blacklistedTags })
);

export const {
  submit: saveMutedTags,
  success: saveMutedTagsSuccess,
  failure: saveMutedTagsFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_MUTED_TAGS');
